import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import setting from "../../config/setting"
import CustomizedChart from '../CSSComponent/chart'
import { extractData } from '../../util/TableUtil'
import 'chartjs-plugin-datalabels'
import CustomizedHeatMap from '../CSSComponent/heatmap.js'
import { styles } from '../CSS/Styles'
import CustomizedTable from '../CSSComponent/table'

const heatMapGrid = [
    [2, 2, 3, 3, 3],
    [2, 2, 2, 3, 3],
    [1, 2, 2, 3, 3],
    [1, 1, 2, 2, 3],
    [1, 1, 1, 2, 2]
]

class ProcurementOverview extends Component {
    constructor(props) {
        super(props)
        this.state = {
            value: 0,
            selected_risk: 'all'
        }
    }

    handleChange = (event, value) => {
        this.setState({ value });
    };

    clickEventFunc = (data)=>{
        this.setState({ selected_risk: data['Risk'] })
    }

    render() {
        const { classes } = this.props
        const { selected_risk } = this.state

        let controlData = []
        // label display on x-axis
        const controlcountlabel = ['Strong', 'Moderate', 'Weak']
        let controlcount = []
        let rrdata = this.props.rrdata
        let alert = this.props.alert
        // console.log(rrdata)
        //console.log(alert)
        let rrdataT1 = rrdata.filter(item => item.tier_level === 'Tier1')
        // console.log(rrdata)
        if (selected_risk !== 'all') {
            rrdata = rrdataT1.filter(item => item.risk_name.split(' ').slice(1).join(' ') === selected_risk);
            alert = alert.filter(item => item.risk_name.split(' ').slice(1).join(' ') === selected_risk);
        } else {
            rrdata = rrdataT1
        }
        // console.log("rr data")
        // console.log(rrdata)

        //extract all control data
        for (let keys in rrdata) {
            controlData = controlData.concat(rrdata[keys]['controls'])
        }

        // count according to strength
        controlcount = controlcount.concat(controlcountlabel.map((label)=>{
            return (
                controlData.reduce(function (n, data) {
                    return n + (data.control_strength == label);
                }, 0)
            )
        }))

        // calculate the sum
        let totalControls = controlcount.reduce((sum, a) => { return (sum + a) })

        const controlStrngth = {
            labels: [['Strong', ''], 'Moderate', 'Weak'],
            datasets: [
                {
                    label: 'No. of Controls',
                    backgroundColor: [setting.COLOR.GREEN, setting.COLOR.AMBER, setting.COLOR.RED],
                    borderWidth: 0,
                    data: controlcount
                }
            ]
        }

        let controlAssuranceCount = [0, 0, 0]
        for (let keys in controlData) {
            if (controlData[keys]['RCSA'] =='Yes') {
                controlAssuranceCount[0] ++
            } if (controlData[keys]['IA'] =='Yes') {
                controlAssuranceCount[1] ++
            } if (controlData[keys]['others'] !='' && controlData[keys]['others'] !='0') {
                controlAssuranceCount[2] ++
            }
        }

        // calculate the sum
        let totalControlsAssurance = controlData.length
        const controlSourceofAssurance = {
            labels: [['RCSA','Performed'], ['Internal Audit','Performed'], ['Other','Assurance']],
            datasets: [
                {
                    stack:'stack1',
                    label: 'Controls of Assurance',
                    backgroundColor: setting.COLOR.AMBER,
                    borderWidth: 0,
                    data: controlAssuranceCount
                },{
                    stack:'stack1',
                    label: 'Total Assurance',
                    backgroundColor: setting.COLOR.BRIGHTYELLOW,
                    borderWidth: 0,
                    data: [totalControlsAssurance - controlAssuranceCount[0],
                        totalControlsAssurance - controlAssuranceCount[1],
                        totalControlsAssurance - controlAssuranceCount[2]
                    ]
                }
            ]
        };


        let actionData = []
        // label display on x-axis
        const actioncountlabel = ['On Track', 'Delayed', 'Completed']
        const actiontypelabel = ['New Control', 'Enhance Control']
        let actioncount = []

        //extract all control data
        for (let keys in rrdata) {
            actionData = actionData.concat(rrdata[keys]['actions'])
        }

        // count according to strength
        actioncount = actioncount.concat(actioncountlabel.map((label)=>{
            return (
                actionData.reduce(function (n, data) {
                    return n + (data['implementation_status'] == label);
                }, 0)
            )
        }))

        let actionTypeCount = []
        actionTypeCount = actionTypeCount.concat(actiontypelabel.map((label)=>{
            return (
                actionData.reduce(function (n, data) {
                    return n + (data['action_type'] == label);
                }, 0)
            )
        }))

        const actionPlan = {
            labels: [['On Track',''], 'Delayed', 'Completed'],
            datasets: [
                {
                    label: 'No. of Action Plans',
                    backgroundColor: [setting.COLOR.GREEN, setting.COLOR.RED, setting.COLOR.GREY],
                    borderWidth: 0,
                    data: actioncount
                }
            ]
        };

        // console.log(this.props.alert)
        let kriAlertLabel = ['Green', 'Amber', 'Red', 'Not Due']
        let kriAlert = []
        
        kriAlert = kriAlert.concat(kriAlertLabel.map((label)=>{
            console.log(alert)
            return (
                alert.reduce(function (n, data) {
                    return n + (data['risk_rating'] == label);
                }, 0)
            )
        }))

        let KRIFollowUpAction = 0
        
        for (let i in alert) {
            KRIFollowUpAction = KRIFollowUpAction + alert[i]['alert_tasks'].length
        }

        const keyRiskIndicator = {
            labels: [['Green',''], 'Amber', 'Red', 'Not Due'],
            datasets: [
                {
                    label: 'No. of KRIs',
                    backgroundColor: [setting.COLOR.GREEN, setting.COLOR.AMBER, setting.COLOR.RED, setting.COLOR.GREY],
                    data: kriAlert
                }
            ]
        }

        let keyToleraceData = 0
        for (let i = 0; i < rrdata.length; i++) {
            keyToleraceData = keyToleraceData + rrdata[i].risk_tolerance.length
        }

        const keyTolerance = {
            labels: [['Breaches In','Risk Tolerance']],
            datasets: [
                {
                    label: 'No. of Tolerances',
                    backgroundColor: setting.COLOR.RED,
                    borderWidth: 0,
                    data: [keyToleraceData]
                }
            ]
        }
        // console.log(this.props.rrdata)
        let header = ['No', 'Category', 'Risk', 'Lead Risk Owners', 'Residual', 'Target']
        let dbheader = ['risk_name', 'category', 'risk_name', 'owners', 'residual_rating', 'target_rating']
        const ERM_NETS_Data = extractData(rrdataT1, header, dbheader)


        return (
            <div flexGrow={1}>
                <Grid container spacing={1}>
                    <Grid item xs={8}>
                        <Card className={classes.cardL1}>
                            <CustomizedTable
                                titleText = 'ABC Group Key Risks'
                                titleAttach = {selected_risk !== 'all' ? <Button style={{marginLeft: 10}} variant='raised' size='small' onClick={(event)=>this.setState({selected_risk:'all'})}>show all</Button> : null}
                                tableHeader = {header}
                                data = {ERM_NETS_Data == null ? null : ERM_NETS_Data}
                                clickEvent = {this.clickEventFunc}
                            />
                        </Card>
                    </Grid>
                    <Grid item xs={4}>
                        <Card className={classes.cardL1} style={{ overflow:'hidden'}}>
                            <CustomizedHeatMap map={heatMapGrid} rrdata = {rrdata} />
                        </Card>
                    </Grid>
                </Grid>

                <Grid container spacing={1} >
                    <Grid item sm={8}>
                        <Grid container spacing={1} >
                            <Grid item xs={4} >
                                <Card className={classes.cardL2}>
                                    <CardContent className={classes.content_chart}>
                                        <CustomizedChart 
                                            data={controlStrngth} 
                                            title={['Control Strength', totalControls + ' Controls in Document', '']}
                                        />
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={4}>
                                <Card className={classes.cardL2}>
                                    <CardContent className={classes.content_chart}>
                                        <CustomizedChart 
                                            data={controlSourceofAssurance} 
                                            title = {['Control Sources of Assurance', '', '']}
                                        />
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={4}>
                                <Card className={classes.cardL2}>
                                    <CardContent className={classes.content_chart}>
                                        <CustomizedChart 
                                            data={actionPlan} 
                                            title = {['Action Plans', actionTypeCount[0] + ' New Controls', actionTypeCount[1] + ' Enhance Existing Controls']}
                                        />
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item sm={4}>
                        <Grid container spacing={1} >
                            <Grid item xs={7}>
                                <Card className={classes.cardL2}>
                                    <CardContent className={classes.content_chart}>
                                        <CustomizedChart 
                                            data={keyRiskIndicator} 
                                            title = {['Key Risk Indicators', KRIFollowUpAction + ' KRI Follow Up Actions', '']}
                                        />
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={5}>
                                <Card className={classes.cardL2}>
                                    <CardContent className={classes.content_chart}>
                                        <CustomizedChart 
                                            data={keyTolerance} 
                                            title = {['Key Tolerance', '15 tolerance metrics', '']}
                                        />
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        )
    }
}
export default withStyles(styles)(ProcurementOverview);


// WEBPACK FOOTER //
// ./src/components/Dashboard/ERMManagementDashboard.js